export const MISSION_CONTROL_DEMO_GRAPH = {
  nodes: [
    {
      id: 'lane-label-1',
      type: 'laneLabel',
      position: { x: 132, y: 46 },
      draggable: false,
      selectable: false,
      connectable: false,
      data: { label: 'Lane 1' },
    },
    {
      id: 'lane-label-2',
      type: 'laneLabel',
      position: { x: 462, y: 46 },
      draggable: false,
      selectable: false,
      connectable: false,
      data: { label: 'Lane 2' },
    },
    {
      id: 'lane-label-3',
      type: 'laneLabel',
      position: { x: 792, y: 46 },
      draggable: false,
      selectable: false,
      connectable: false,
      data: { label: 'Lane 3' },
    },
    {
      id: 'lane1-preflight',
      type: 'workflowNode',
      position: { x: 140, y: 120 },
      data: {
        label: 'preflight',
        nodeType: 'preflight',
        status: 'completed',
      },
    },
    {
      id: 'lane1-execute',
      type: 'workflowNode',
      position: { x: 140, y: 290 },
      data: {
        label: 'execute_live',
        nodeType: 'execute_live',
        status: 'running',
      },
    },
    {
      id: 'lane1-script',
      type: 'workflowNode',
      position: { x: 140, y: 460 },
      data: {
        label: 'generate_script',
        nodeType: 'generate_script',
        status: 'pending',
      },
    },
    {
      id: 'lane2-preflight',
      type: 'workflowNode',
      position: { x: 470, y: 120 },
      data: {
        label: 'preflight',
        nodeType: 'preflight',
        status: 'pending',
      },
    },
    {
      id: 'lane2-execute',
      type: 'workflowNode',
      position: { x: 470, y: 290 },
      data: {
        label: 'execute_live',
        nodeType: 'execute_live',
        status: 'pending',
      },
    },
    {
      id: 'lane2-script',
      type: 'workflowNode',
      position: { x: 470, y: 460 },
      data: {
        label: 'generate_script',
        nodeType: 'generate_script',
        status: 'pending',
      },
    },
    {
      id: 'lane3-preflight',
      type: 'workflowNode',
      position: { x: 800, y: 120 },
      data: {
        label: 'preflight',
        nodeType: 'preflight',
        status: 'pending',
      },
    },
    {
      id: 'lane3-execute',
      type: 'workflowNode',
      position: { x: 800, y: 290 },
      data: {
        label: 'execute_live',
        nodeType: 'execute_live',
        status: 'pending',
      },
    },
    {
      id: 'lane3-script',
      type: 'workflowNode',
      position: { x: 800, y: 460 },
      data: {
        label: 'generate_script',
        nodeType: 'generate_script',
        status: 'pending',
      },
    },
  ],
  edges: [
    {
      id: 'lane1-preflight-execute',
      source: 'lane1-preflight',
      target: 'lane1-execute',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'lane1-execute-script',
      source: 'lane1-execute',
      target: 'lane1-script',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'lane2-preflight-execute',
      source: 'lane2-preflight',
      target: 'lane2-execute',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'lane2-execute-script',
      source: 'lane2-execute',
      target: 'lane2-script',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'lane3-preflight-execute',
      source: 'lane3-preflight',
      target: 'lane3-execute',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'lane3-execute-script',
      source: 'lane3-execute',
      target: 'lane3-script',
      type: 'smoothstep',
      animated: true,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
  ],
  nodeConfigs: {},
  stateSchema: null,
};
